import React, { useEffect, useRef, useState } from 'react';
// import loaderImage from '../../../assets/customLoader/customLoader.png';
import './customLoader.scss';

// Module-scope index keeps the rotating-message progress across remounts.
// During bootstrap the loader is mounted by BaseLayout's Suspense fallback and
// then again by CommonRedirection — without this, the second mount would reset
// the copy back to the first message even though several seconds have already
// elapsed. Reset happens on full page reload (module re-evaluates).
let _customLoaderMessageIndex = 0;

export default function CustomLoader() {
	//@ts-ignore
	const lang = navigator.language || navigator?.userLanguage
	const messageList_en = ["Setting up your communities ...", "Downloading the binaries...", "Loading your settings...", "Almost there! Just a few more seconds..."]
	const messageList_es = ["Configurando tus comunidades...", "Descargando los binarios...", "Cargando tu configuración...", "¡Casi llegamos! Sólo unos segundos más..."];
	const messageList = lang === "es" ? messageList_es : messageList_en
	const [current, setCurrent] = useState<number>(_customLoaderMessageIndex);
	const intervalRef = useRef<NodeJS.Timeout | undefined>(undefined);

	useEffect(() => {
		intervalRef.current = setInterval(() => {
			if (current < messageList.length - 1) {
				const next = current + 1;
				_customLoaderMessageIndex = next;
				setCurrent(next);
			} else {
				clearInterval(intervalRef.current);
			}
		}, 2500);
		return () => {
			clearInterval(intervalRef.current);
		}
	}, [current]);

	return (
		<div className='loaderWrapper'>
			{/* <img className='loaderImage' src={loaderImage} alt="loader" width={105} height={105} /> */}
			<div className='message'>{messageList[current]}</div>
			<div className="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
		</div>
	)
}
